import { Box, Checkbox, List, ListItem, Typography } from "@mui/material"
import { useSelector } from "react-redux"
import { ProvidersMetricsListItem, ProvidersMetricsListWrapper } from "./Atom"
import {
  setAllProviderMetrics,
  setFilteredProviderMetrics,
  setProvidersMetricTabs,
  setSelectedProviderMetrics,
} from "../../../redux/slices/providersSlice"
import { useDispatch } from "react-redux"
import { useEffect, useState } from "react"
import { StyledMenuItem } from "../../Dropdown/Atom"

type Props = {}

const ProvidersMetricsList = (props: Props) => {
  const dispatch = useDispatch()

  const allProviderMetrics = useSelector((state: any) => {
    return state.providers.allProviderMetrics
  })
  const filteredProviderMetrics = useSelector((state: any) => {
    return state.providers.filteredProviderMetrics
  })
  const selectedProviderMetrics = useSelector((state: any) => {
    return state.providers.selectedProviderMetrics
  })
  const selectedSpeciality = useSelector((state: any) => {
    return state.providers.selectedSpeciality
  })
  const selectedProvidersGroups = useSelector((state: any) => {
    return state.providers.selectedProvidersGroups
  })
  const selectedProvidersRegions = useSelector((state: any) => {
    return state.providers.selectedProvidersRegions
  })
  const selectedProvidersOffices = useSelector((state: any) => {
    return state.providers.selectedProvidersOffices
  })
  const selectedProviders = useSelector((state: any) => {
    return state.providers.selectedProviders
  })
  const [checkedMenuItems, setCheckedMenuItems] = useState<Array<number>>([])
  const [selectAll, setSelectAll] = useState(false) // New state for "Select All"

  const handleCheckedMenuItems = (metric: any) => {
    const metricId = metric?.metric_id
    if (metric === "Select All") {
      if (filteredProviderMetrics.length === checkedMenuItems.length) {
        setCheckedMenuItems([])
        dispatch(setSelectedProviderMetrics([]))
        return
      }
      const All = filteredProviderMetrics?.map((item: any) => item.metric_id)
      setCheckedMenuItems(All)
      dispatch(setSelectedProviderMetrics(filteredProviderMetrics))
      return
    }
    if (checkedMenuItems.includes(metricId)) {
      setCheckedMenuItems(
        checkedMenuItems.filter((item: any) => item !== metricId),
      )
      dispatch(
        setSelectedProviderMetrics(
          selectedProviderMetrics.filter(
            (localProviderMetric: any) =>
              localProviderMetric?.metric_id !== metricId,
          ),
        ),
      )
    } else {
      setCheckedMenuItems([...checkedMenuItems, metricId])
      dispatch(setSelectedProviderMetrics([...selectedProviderMetrics, metric]))
    }

    //console.log("filteredProviderMetrics", checkedMenuItems)
  }

  const providerMetrics = filteredProviderMetrics
  const isAllSelected =
    filteredProviderMetrics?.length > 0 &&
    checkedMenuItems?.length >= filteredProviderMetrics?.length

  useEffect(() => {
    setCheckedMenuItems([])
    dispatch(setSelectedProviderMetrics([]))
  }, [
    selectedSpeciality,
    selectedProvidersGroups,
    selectedProvidersRegions,
    selectedProvidersOffices,
    selectedProviders,
  ])

  return (
    <ProvidersMetricsListWrapper>
      {allProviderMetrics?.length ? (
        providerMetrics?.length ? (
          <>
            <ProvidersMetricsListItem
              onClick={() => handleCheckedMenuItems("Select All")}
              sx={{
                fontSize: "14px",
              }}
            >
              <Checkbox
                size="small"
                name="select-checkbox"
                checked={isAllSelected}
              />
              Select All
            </ProvidersMetricsListItem>
            {providerMetrics?.map((metric: any) => (
              <ProvidersMetricsListItem
                key={metric.metric_id}
                onClick={() => handleCheckedMenuItems(metric)}
                sx={{
                  backgroundColor: checkedMenuItems?.includes(metric?.metric_id)
                    ? "#dce7fe"
                    : "",
                }}
              >
                <Checkbox
                  size="small"
                  checked={checkedMenuItems?.includes(metric?.metric_id)}
                />
                <Typography fontSize={14}>{metric?.metric_name}</Typography>
              </ProvidersMetricsListItem>
            ))}
          </>
        ) : (
          <Box
            sx={{
              display: "flex",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            No Data
          </Box>
        )
      ) : (
        <Box
          sx={{
            display: "flex",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Select Speciality
        </Box>
      )}
    </ProvidersMetricsListWrapper>
  )
}

export default ProvidersMetricsList
